export enum Support {
    full = 'full',
    sponsored = 'sponsored',
    partial = 'partial',
    none = 'none'
}
